module.exports = __webpack_public_path__ + "static/media/new_pack_super_dog_285x350_FR.6cbdf5e0.png";